/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { Appointment } from '../models/appointment';
import { ServiceTypes } from '../models/service-types';


/**
 * Appointment operations
 */
@Injectable({
  providedIn: 'root',
})
export class AppointmentService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getAllAppointments
   */
  static readonly GetAllAppointmentsPath = '/appointments';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllAppointments()` instead.
   *
   * This method doesn't expect any response body
   */
  getAllAppointments$Response(params: {
    startTime: string;
    endTime: string;

  }): Observable<StrictHttpResponse<Array<Appointment>>> {

    const rb = new RequestBuilder(this.rootUrl, '/appointments', 'get');
    if (params) {

      rb.query('startTime', params.startTime);
      rb.query('endTime', params.endTime);
    }
    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<Appointment>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAllAppointments$Response()` instead.
   *
   * This method doesn't expect any response body
   */
  getAllAppointments(params: {
    startTime: string;
    endTime: string;

  }): Observable<Array<Appointment>> {

    return this.getAllAppointments$Response(params).pipe(
      map((r: StrictHttpResponse<Array<Appointment>>) => r.body as Array<Appointment>)
    );
  }

  /**
   * Path part for operation getAllAppointmentsFreeSlots
   */
  static readonly GetAllAppointmentsFreeSlotsPath = '/appointments/free-slots';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllAppointmentsFreeSlots()` instead.
   *
   * This method doesn't expect any response body
   */
  getAllAppointmentsFreeSlots$Response(params: {
    startTime: string;
    endTime: string;

  }): Observable<StrictHttpResponse<Array<{ 'type': ServiceTypes, 'idsOffFreeSlots': Array<number> }>>> {

    const rb = new RequestBuilder(this.rootUrl, '/appointments/free-slots', 'get');
    if (params) {

      rb.query('startTime', params.startTime);
      rb.query('endTime', params.endTime);
    }
    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<{ 'type': ServiceTypes, 'idsOffFreeSlots': Array<number> }>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAllAppointmentsFreeSlots$Response()` instead.
   *
   * This method doesn't expect any response body
   */
  getAllAppointmentsFreeSlots(params: {
    startTime: string;
    endTime: string;

  }): Observable<Array<{ 'type': ServiceTypes, 'idsOffFreeSlots': Array<number> }>> {

    return this.getAllAppointmentsFreeSlots$Response(params).pipe(
      map((r: StrictHttpResponse<Array<{ 'type': ServiceTypes, 'idsOffFreeSlots': Array<number> }>>) => r.body as Array<{ 'type': ServiceTypes, 'idsOffFreeSlots': Array<number> }>)
    );
  }

}
